import { render, staticRenderFns } from "./code_identification.vue?vue&type=template&id=4124da51&scoped=true&"
import script from "./code_identification.vue?vue&type=script&lang=js&"
export * from "./code_identification.vue?vue&type=script&lang=js&"
import style0 from "./code_identification.vue?vue&type=style&index=0&id=4124da51&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4124da51",
  null
  
)

export default component.exports